export const getDisplayedTempNotifications = (state) =>
  state.temporaryNotifications.displayed;
export const getPendingTempNotifications = (state) =>
  state.temporaryNotifications.pending;
